(ns practitest.frontend.reports.dnd-selector
  (:require-macros
   [reagent.core :refer [with-let]])
  (:require
   [reagent.core            :as reagent]
   [practitest.frontend.common-old-fe.rbdnd   :as rbdnd]
   [practitest.frontend.common-old-fe.logging :as log]))

(defn list-style [dragging-over?]
  {:background    (if dragging-over? "silver" "white")
   :padding-left  "16px"
   :padding-right "8px"
   :padding-top   "8px"
   :margin        0
   :min-width     200
   :height        400
   :overflow-y    "auto"
   :border-radius "4px"
   :border        "2px solid DarkGray"
   :transition    "background-color 0.1s ease"})

(defn item-style [dragging?]
  {:user-select   "none"
   :background    "white"
   :border        "1px solid gray"
   :border-radius "4px"
   :padding       "8px"
   :margin        "0 0 8px 0"
   :opacity       (if dragging? 0.8 1.0)
   :transition    "opacity 0.1s ease"})

(defn selector-ui
  "`left-header` - header component shown above left droppable.
   `right-header` - header component shown above right droppable.
   `left-items` - array of items showed in the left droppable, each item is a tuple of (unique-id, component to show)
   `right-items` - array of items showed in the right droppable, each item is a tuple of (unique-id, component to show)
   `save-fn` function called if user chooses to save the changes, accepts two parameters, new `left-items` and new `right-items`
   `cancel-fn` function called if user chooses to cancel the changes, no parameters"
  [{:keys [left-header right-header left-items right-items save-fn cancel-fn]}]
  (with-let [state (reagent/atom {:left-items  left-items
                                  :right-items right-items})]
    [:<>
     [rbdnd/drag-drop-context
      {:on-drag-end (fn [source destination draggable-id]
                      (log/info :selector-ui :on-drag-end source destination draggable-id)
                      (when destination
                        (swap! state
                               (fn [current-state]
                                 (let [item (first
                                             (filter #(= draggable-id (first %))
                                                     (get current-state (keyword (:droppableId source)))))]
                                   (-> current-state
                                       (update (keyword (:droppableId source))
                                               (fn [items]
                                                 ;; just remove the draggable
                                                 (remove #(= draggable-id (first %)) items)))
                                       (update (keyword (:droppableId destination))
                                               (fn [items]
                                                 ;; insert the draggable
                                                 (concat (vec (subvec (vec items) 0 (:index destination)))
                                                         [item]
                                                         (vec (subvec (vec items) (:index destination))))))))))))}
      (let [{:keys [left-items right-items]} @state]
        [:div.row
         {:style {:user-select "none"
                  ;; :min-width   900
                  :overflow-x  "auto"}}
         [:div.col-6
          ;; {:style {:padding "0 20px 0 100px"}}
          [rbdnd/droppable
           {:id        "left-items"
            :direction "vertical"
            :style-f   list-style
            :title     left-header}
           (for [[i [id component]] (map-indexed vector left-items)]
             [rbdnd/draggable
              {:id id :ix i :style-f item-style}
              component])]]
         [:div.col-6
          [rbdnd/droppable
           {:id        "right-items"
            :direction "vertical"
            :style-f   list-style
            :title     right-header}
           (for [[i [id component]] (map-indexed vector right-items)]
             [rbdnd/draggable
              {:id id :ix i :style-f item-style}
              component])]]])]
     [:div.row
      [:div.col-md-12
       {:style {:text-align "center"}}
       [:div.btn-group
        {:style {:padding-top "8px"}}
        [:button.btn.btn-primary
         {:type     :button
          :on-click (fn [_]
                      (let [{:keys [left-items right-items]} @state]
                        (save-fn left-items right-items)))}
         "Save"]
        [:button.btn.btn-default
         {:type     :button
          :on-click #(cancel-fn)}
         "Cancel"]]]]]))
